import axios from 'axios'
import AppConfig from '@/config'
import { authHeader } from '@/constants/storageKeys'
import { guestHeader } from '@/utils/guestId'

interface PromoInitRequest {
	promolink: string
	/** Строка запроса целиком, с ведущим '?', как её прислал партнёр. */
	query: string
}

interface PromoInitResponse {
	promoter_id: string | null
}

export async function postPromoInit(promolink: string, query: string): Promise<void> {
	const body: PromoInitRequest = { promolink, query }
	// apiUrl уже заканчивается на '/', поэтому путь без ведущего слэша — как в api/sse.ts.
	await axios.post<PromoInitResponse>(`${AppConfig.apiUrl}promo/init`, body, {
		headers: { ...authHeader(), ...guestHeader() }
	})
}
